import { useState } from 'react';
import { Outlet} from 'react-router-dom'; 
import HeaderPublic from '../header/HeaderPublic';
import PageNameAndSearch from '../PageNameAndSearchSection/pageNameAndSearch';

export default function PublicLayout() {
  const [navClassList, setNavClassList] = useState([]);
  const [placeholderToggle, setPlaceholderToggle] = useState(
    'page-name-and-search-placeholder'
  );

  return (
    <> 
      <div className='header-wrap'>
        <header className='main-header-wrap'>
          <HeaderPublic />
        </header>
        <div className='main-page-name-and-search-wrap'>
          <div className={placeholderToggle}></div>
          <nav className={navClassList.join(' ')}>
            <PageNameAndSearch />
          </nav>
        </div>
      </div>
      <main>
        <Outlet />
      </main>
    </>
  );
}
